import React from "react";
import ReactDOM from "react-dom";

// bring in carbon styles
import 'carbon-components/css/carbon-components.min.css';
import "./index.css";

import App from "./App";

import { AppContainer } from "react-hot-loader";

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <App />
    </AppContainer>,
    document.getElementById("root")
  );
};

// Render once
render(App);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./App", () => {
    render(App);
  });
}
